if (!customElements.get('nap-trust-slider')) {
  customElements.define('nap-trust-slider', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      clearTimeout(this.timer);
      const track = this.querySelector('.trust-benefits__inner');
      if (!track || track.children.length < 2) return;
      const { signal } = this.controller = new AbortController();
      const mobile = matchMedia('(max-width: 749px)');
      const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      let interacting = false;
      const schedule = () => {
        clearTimeout(this.timer);
        if (!mobile.matches || reducedMotion.matches || document.hidden || interacting || this.contains(document.activeElement)) return;
        this.timer = setTimeout(() => {
          const index = Math.round(track.scrollLeft / track.clientWidth);
          const next = (index + 1) % track.children.length;
          track.scrollTo({ left: next * track.clientWidth, behavior: next === 0 ? 'instant' : 'smooth' });
          schedule();
        }, 2000);
      };
      track.addEventListener('pointerdown', () => { interacting = true; clearTimeout(this.timer); }, { signal, passive: true });
      const resume = () => { interacting = false; schedule(); };
      window.addEventListener('pointerup', resume, { signal });
      window.addEventListener('pointercancel', resume, { signal });
      track.addEventListener('scroll', schedule, { signal, passive: true });
      this.addEventListener('focusin', () => clearTimeout(this.timer), { signal });
      this.addEventListener('focusout', () => requestAnimationFrame(schedule), { signal });
      document.addEventListener('visibilitychange', schedule, { signal });
      mobile.addEventListener('change', schedule, { signal });
      reducedMotion.addEventListener('change', schedule, { signal });
      schedule();
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.controller?.abort();
    }
  });
}
